<template>
  <div class="list_page">

    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="80px">
        <!-- 问题序号 -->
        <el-form-item label="问题序号">
          <el-input v-model="queryParams.questionNum" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- 国家 -->
        <el-form-item label="国家">
          <el-select clearable filterable v-model="queryParams.countryId" placeholder="请选择">
            <el-option v-for="item in nationList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item label="车型">
          <el-select filterable v-model="queryParams.carModel" placeholder="请选择" clearable>
            <el-option v-for="item in carTypeList" :key="item.codeText" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 反馈单号 -->
        <el-form-item label="反馈单号">
          <el-input v-model="queryParams.feedbackFormId" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- 问题描述 -->
        <el-form-item label="问题描述">
          <el-input v-model="queryParams.questionContent" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- 零部件类别 -->
        <el-form-item label="零部件类别">
          <el-input v-model="queryParams.componentCategory" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- 零部件代码 -->
        <el-form-item label="零部件代码">
          <el-input v-model="queryParams.faultPartNumber" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- 零部件名称 -->
        <el-form-item label="零部件名称">
          <el-input v-model="queryParams.faultPartName" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- 故障来源 -->
        <!-- <el-form-item label="故障来源">
          <el-select filterable clearable v-model="queryParams.carType">
            <el-option label="售前车" :value="0"></el-option>
            <el-option label="售后车" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 状态 -->
        <!-- <el-form-item label="状态">
          <el-select filterable clearable v-model="queryParams.taskStatus">
            <el-option label="待处理" :value="0"></el-option>
            <el-option label="处理中" :value="1"></el-option>
            <el-option label="已关闭" :value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 车型 -->
        <!-- <el-form-item label="车型">
          <el-select
            filterable
            v-model="queryParams.carModel"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.codeText"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 车辆属性 -->
        <!-- <el-form-item label="车辆属性">
          <el-select v-model="queryParams.carAttribute" filterable clearable>
            <el-option label="燃油车" :value="0"></el-option>
            <el-option label="电动车" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 处理类型 -->
        <!-- <el-form-item label="处理类型">
          <el-select v-model="queryParams.taskId" filterable clearable>
            <el-option
              v-for="(item, index) in taskList"
              :key="index"
              :label="item.taskName"
              :value="item.taskId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 提交时间 -->
        <!-- <el-form-item label="提交日期">
          <el-date-picker
            v-model="queryParams.submitTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item> -->
        <!-- 是否典型问题 -->
        <!-- <el-form-item label="是否典型问题" v-if="role === '技术专家'">
          <el-select filterable clearable v-model="queryParams.typicalProblem">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 判定类型 -->
        <!-- <el-form-item label="判定类型">
          <el-select v-model="queryParams.reviewType" filterable clearable>
            <el-option label="未判定" :value="0"></el-option>
            <el-option label="类型一" :value="1"></el-option>
            <el-option label="类型二" :value="2"></el-option>
            <el-option label="类型三" :value="3"></el-option>
            <el-option label="已有解决方案" :value="4"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 操作 -->
          <el-button type="primary" size="small" @click="doSearch">查询</el-button>
          <el-button type="primary" plain size="small" @click="handleResetQuery">重置</el-button>
      </el-form>
    </div>

    <!-- 表格内容 -->
    <div class="table-container">
      <el-table ref="tableRef" highlight-current-row :border="true" stripe :data="tableData">
        <!-- 序号、国家、车型、反馈单号、问题描述、零部件类别、零部件代码、零部件名称 -->
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 问题序号 -->
        <el-table-column prop="questionNum" label="问题序号" min-width="130px" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <div class="questionNum">
              <img v-if="scope.row.importantType === 1" class="title-icon" src="@/assets/img/import-icon.svg" />
              {{ scope.row.questionNum }}
            </div>
          </template>
        </el-table-column>
        <!-- 国家 -->
        <el-table-column prop="country" label="国家" min-width="90px" align="center" />
        <!-- 车型 -->
        <el-table-column prop="carModel" label="车型" min-width="90px" align="center" />
        <!-- 反馈单号 -->
        <el-table-column prop="feedbackFormId" label="反馈单号" show-overflow-tooltip align="center"
          :min-width="$getColumnWidth('feedbackFormId', tableData)">
          <template slot-scope="scope">
            <el-button type="text" @click="scope.row.reviewType == 3 ? handleLook(scope.row, scope.$index) : handleLookDetail(scope.row, scope.$index)">{{ scope.row.feedbackFormId
              }}</el-button>
          </template>
        </el-table-column>
        <!-- 问题描述 -->
        <el-table-column prop="questionContent" label="问题描述" min-width="520">
          <template slot-scope="scope">
            <span class="gzms">{{ scope.row.questionContent }}</span>
          </template>
        </el-table-column>
        <!-- 零部件类别 -->
        <el-table-column prop="componentCategory" label="零部件类别" min-width="140px" align="center"
          show-overflow-tooltip />
        <!-- 零部件代码 -->
        <el-table-column prop="faultPartNumber" label="零部件代码" min-width="140px" align="center" show-overflow-tooltip />
        <!-- 零部件名称 -->
        <el-table-column prop="faultPartName" label="零部件名称" min-width="140px" align="center" show-overflow-tooltip />
        <!-- 日期 -->
        <!-- <el-table-column
          prop="submitTime"
          label="日期"
          min-width="160px"
          align="center"
        /> -->
        <!-- 发生原因 -->
        <!-- <el-table-column
          prop="questionContentCh"
          label="发生原因"
          min-width="140px"
          align="center"
          show-overflow-tooltip
        /> -->
        <!-- 临时措施 -->
        <!-- <el-table-column
          prop="emergencyMeasure"
          label="临时措施"
          min-width="140px"
          align="center"
          show-overflow-tooltip
        /> -->
        <!-- 根因分析 -->
        <!-- <el-table-column
          prop="causeAnalysis"
          label="根因分析"
          min-width="140px"
          align="center"
          show-overflow-tooltip
        /> -->
        <!-- 永久措施 -->
        <!-- <el-table-column
          prop="permanentPlan"
          label="永久措施"
          min-width="140px"
          align="center"
          show-overflow-tooltip
        /> -->
        <!-- 操作 -->
        <el-table-column label="操作" align="center" width="160px" fixed="right">
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button size="mini" type="text" @click="handleLook(scope.row, scope.$index)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination :total="total" :page.sync="pageNum" :limit.sync="pageSize" @pagination="handlePaginationChange" />
      </div>
    </div>
  </div>
</template>

<script>
import listCurd from '@/mixins/listCurd'
import { getDictItem } from '@/util/dict'
import { typicalProblemListApi } from '@/api/feedback'
import {
  problemDetailListApi,
} from "@/api/feedback";
import { setStorageNew, getSession } from '@/util/localStor'

export default {
  components: {},
  mixins: [listCurd],
  data() {
    const { data = {}, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route.query.searchObj)
      : {}
    return {
      carTypeList: [],
      pageNum: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      listMethod: typicalProblemListApi,
      nationList: Object.values(getSession('nationList')).slice(1),
      // 查询参数
      queryParams: {
        questionNum: data.questionNum || '',
        feedbackFormId: data.feedbackFormId || '',
        countryId: data.countryId || '',
        // carType: data.carType ?? "",
        taskStatus: data.taskStatus ?? 0
        // carModel: data.carModel || ''
        // carAttribute: data.carAttribute ?? "",
        // taskId: data.taskId || "",
        // submitTime: data.submitTime || "",
        // reviewType: data.reviewType ?? ""
      }

    }
  },
  created() {
    // 获取车型列表
    this.getCarTypeList()
    // 获取表格数据
    this.getList()
  },
  methods: {
    // 获取车型列表
    async getCarTypeList() {
      this.carTypeList = await getDictItem('carType')
    },
    // 查看
    handleLook(data = {}, index) {
      setStorageNew('problemData', data)
      // 记录当前筛选条件
      this.recordSearchObj()
      this.$nextTick(() => {
        this.$router.push({
          path: '/problemDetaillist/' + data.questionId,
          // path: "/problemDetailNew/" + data.taskId,
          // path: "/problemDetail/" + data.taskId,
          query: {
            questionNum: data.questionNum,
            searchObj: JSON.stringify({
              data: {
                ...this.getParams().data
              },
              page: {
                pageNum: this.getColumnIndex(index),
                pageSize: 1
              }
            })
          }
        })
      })
    },// 跳过二级列表 进入详情页
    async handleLookDetail(data = {}, index) {
      const res = await problemDetailListApi({
        data:{
          questionId: data.questionId
        }
      });
      data = res.data.records[0];
      localStorage.setItem("problemId", data.questionId);
      setStorageNew("problemData", data);
      // 记录当前筛选条件
      this.recordSearchObj();
      this.$nextTick(() => {
        this.$router.push({
          path: "/problemDetailNew/" + data.taskId,
          // path: "/problemDetail/" + data.taskId,
          query: {
            questionNum: data.questionNum,
            searchObj: JSON.stringify({
              data: {
                ...this.getParams().data,
              },
              page: {
                pageNum: this.getColumnIndex(index),
                pageSize: 1,
              },
            }),
          },
        });
      });
    }


  }
}
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.table-container {
  .questionNum {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    img {
      position: absolute;
      left: -25px;
    }
  }

  .gzms {
    min-width: 220px;
    word-wrap: break-word;
    word-break: keep-all;
  }
}
</style>
